import React from 'react';

export const LinkedInSvg = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-241.000000, -131.000000)">
        <g transform="translate(241.000000, 131.000000)">
          <circle
            fill="#3F97CA"
            fillRule="nonzero"
            cx="20"
            cy="20"
            r="20"
          ></circle>
          <path
            d="M10.035,30.10875 L14.825,30.10875 L14.825,15.6975 L10.035,15.6975 L10.035,30.10875 Z M12.46125,8.75 C10.82125,8.75 9.75,9.82625 9.75,11.24 C9.75,12.62375 10.79125,13.73 12.39875,13.73 L12.43,13.73 C14.10125,13.73 15.14,12.62375 15.14,11.24 C15.10875,9.82625 14.10125,8.75 12.46125,8.75 L12.46125,8.75 Z M32.10125,21.845 L32.10125,30.10875 L27.31,30.10875 L27.31,22.39875 C27.31,20.4625 26.6175,19.14 24.88375,19.14 C23.56,19.14 22.7725,20.03 22.42625,20.8925 C22.3,21.2 22.26625,21.62875 22.26625,22.06 L22.26625,30.10875 L17.475,30.10875 C17.475,30.10875 17.53875,17.04875 17.475,15.6975 L22.26625,15.6975 L22.26625,17.74 C22.2575,17.755 22.24375,17.77125 22.235,17.78625 L22.26625,17.78625 L22.26625,17.74 C22.90375,16.76 24.04,15.35875 26.585,15.35875 C29.73875,15.35875 32.10125,17.41875 32.10125,21.845 L32.10125,21.845 Z"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </g>
  </svg>
);
